import { render, staticRenderFns } from "./CutOffReminder.vue?vue&type=template&id=55540395"
import script from "./CutOffReminder.vue?vue&type=script&lang=js"
export * from "./CutOffReminder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports